import React from 'react';
import { Target, Users, Award, Heart } from 'lucide-react';

const AimsObjectives: React.FC = () => {
  const objectives = [
    {
      icon: <Target className="w-6 h-6" />,
      text: "It aims all round development of children by drawing out the best in them.",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: <Users className="w-6 h-6" />,
      text: "Aims all quality of self reliance, mutual help, team spirit, service of general awareness and leadership.",
      color: "from-purple-500 to-pink-500"
    },
    {
      icon: <Award className="w-6 h-6" />,
      text: "Aims at qualitative and excellence in scholastic as well as co-scholastic fields in particular and life in general.",
      color: "from-green-500 to-emerald-500"
    },
    {
      icon: <Heart className="w-6 h-6" />,
      text: "Aims at character building of the children and propagation of patriotic sentiments.",
      color: "from-red-500 to-orange-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-6">
      <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16 animate-fade-in">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full mb-6 shadow-lg">
            <Target className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
            Aims & Objectives
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-indigo-600 to-purple-600 mx-auto rounded-full"></div>
        </div>

        {/* Primary Aim Card */}
        <div className="mb-16 transform hover:scale-105 transition-all duration-500">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-white/20 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-pink-500/10 rounded-3xl"></div>
            <div className="relative z-10">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                  <Heart className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-800">Primary Aim</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed font-medium">
                The Primary aim of the school is <span className="font-bold text-indigo-600">spontaneous growth and development of individual</span> - 
                physical, mental, moral, spiritual values and ultimately to form her/him into a <span className="font-bold text-purple-600">true citizen of the nation</span>.
              </p>
            </div>
          </div>
        </div>

        {/* Objectives Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {objectives.map((objective, index) => (
            <div 
              key={index}
              className="group transform hover:scale-105 transition-all duration-500 hover:shadow-2xl"
              style={{
                animationDelay: `${index * 200}ms`
              }}
            >
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/30 h-full relative overflow-hidden">
                {/* Gradient Background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${objective.color} opacity-5 group-hover:opacity-10 transition-opacity duration-300 rounded-2xl`}></div>
                
                {/* Content */}
                <div className="relative z-10 h-full flex flex-col">
                  <div className={`w-14 h-14 bg-gradient-to-r ${objective.color} rounded-xl flex items-center justify-center mb-4 shadow-lg group-hover:shadow-xl transition-shadow duration-300`}>
                    <div className="text-white">
                      {objective.icon}
                    </div>
                  </div>
                  
                  <p className="text-gray-700 leading-relaxed flex-grow font-medium group-hover:text-gray-800 transition-colors duration-300">
                    {objective.text}
                  </p>
                  
                  {/* Decorative Element */}
                  <div className={`mt-4 h-1 bg-gradient-to-r ${objective.color} rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left`}></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-gradient-to-r from-pink-400/20 to-orange-400/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-r from-green-400/20 to-cyan-400/20 rounded-full blur-2xl animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
      `}</style>
    </div>
  );
};

export default AimsObjectives;